import { useState } from 'react'

// Custom input that includes a label, and a show password functionality
// recommended to use with a form component with multiple fields
export const FormInput = ({
	name, // name for input component, string
	type, // type of input, string
	enableShowPassword, // enable show password functionality, boolean
	placeholder, // string
	setDataFunction, // a useState function that sets data, function
	data, // json object recommended to work properly
	autoFocus, //
	value, // value of the input
	min, // min value for number inputs, number
	max, // max value for number inputs, number
	required, // for required inputs, boolean
	disabled, // disable the input field, boolean
	data_cy, // for cypress tests
}) => {
	const [showPassword, setShowPassword] = useState(false)

	// toggles between showing and hiding password
	const handlePassword = () => {
		setShowPassword((prev) => !prev)
	}

	// update useState data on change (json object)
	const handleChange = (e) => {
		setDataFunction({
			...data,
			[e.target.name]: e.target.value,
		})
	}

	return (
		<div>
			<label htmlFor={placeholder}>{placeholder && placeholder}</label>
			<input
				min={min}
				max={max}
				value={value}
				name={name}
				required={required}
				placeholder={placeholder}
				id={placeholder}
				type={
					enableShowPassword
						? showPassword
							? 'text'
							: 'password'
						: type
				}
				onChange={handleChange}
				autoFocus={autoFocus}
				disabled={disabled}
				data-cy={data_cy}
			/>
			<p onClick={handlePassword}>
				{enableShowPassword &&
					(showPassword ? 'Hide password' : 'Show password')}
			</p>
		</div>
	)
}
